import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { CONTACT_US_FORM_FIELDS } from "@thkStore/Constants/ContactUs/formFields";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    city: state.components.contactUsForm.fieldValues[CONTACT_US_FORM_FIELDS.city],
});

const mapDispatchToProps = { setFieldValue };

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CityStyles {
    cityTextField?: TextFieldPresentationProps;
}

export const cityStyles: CityStyles = {};

const styles = cityStyles;

const City: React.FC<Props> = ({ fields, city, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [errorMessage, setErrorMessage] = React.useState("");

    React.useEffect(() => {
        contactFormContext.validators.city = validate;
        if (typeof city !== "undefined") validate();
    }, [city, isRequired]);

    const validate = () => {
        const error = isRequired && !city
            ? (siteMessage("Field_Required", label) as string)
            : "";
        setErrorMessage(error);
        return !error;
    };

    return (
        <TextField
            {...styles.cityTextField}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={city || ""}
            error={errorMessage}
            onChange={e => setFieldValue({ key: CONTACT_US_FORM_FIELDS.city, value: e.target.value })}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(City),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            { name: fields.label, displayName: "Label", editorTemplate: "TextField", fieldType: "Translatable", defaultValue: "City", isRequired: true },
            { name: fields.hintText, displayName: "Hint Text", editorTemplate: "TextField", fieldType: "Translatable", defaultValue: "Enter City", isRequired: true },
            { name: fields.isRequired, displayName: "Required Field", editorTemplate: "CheckboxField", defaultValue: true, fieldType: "General" },
        ],
    },
};

export default widgetModule;
